import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { ContactsService } from '../../store/services/contacts.service';
import { select, Store } from '@ngrx/store';
import { IReducers } from '../../store/reducers';
import { IUserSessionData } from '../../store/models/user.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-left-message',
  templateUrl: './left-message.component.html',
  styleUrls: ['./left-message.component.scss'],
})
export class LeftMessageComponent implements OnInit {
  @ViewChild('editor', { read: EditorComponent }) editor: EditorComponent;

  inputForm: FormGroup;

  @Input() contactName: string;

  constructor(
    private readonly contactsService: ContactsService,
    private readonly store$: Store<IReducers>
  ) {}

  ngOnInit() {
    this.store$
      .select('user')
      .pipe(select(state => state.sessionData))
      .subscribe((userSession: IUserSessionData) => {
        this.inputForm.addControl(
          'subject',
          new FormControl('Follow up to my voicemail message', [
            Validators.required,
          ])
        );
        this.inputForm.addControl(
          'message',
          new FormControl('', [Validators.required])
        );

        this.contactsService.getVipMessageReply().subscribe(res => {
          if (res && res.reply_content && this.editor) {
            this.inputForm
              .get('message')
              .setValue(
                res.reply_content.replace('{contact_name}', this.contactName) +
                  '<br/>' +
                  userSession.signature || ''
              );
          }
        });
      });
  }
}
